import React, { useState } from 'react';
import { Box, Typography, Button, CircularProgress, Chip } from '@mui/material';
import { Visibility, ExitToApp, Warning } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ImpersonationBanner = () => {
  const { user, isImpersonating, exitImpersonation } = useAuth();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  if (!isImpersonating()) return null;

  const handleExit = async () => {
    setExiting(true);
    await exitImpersonation();
    setExiting(false);
    toast.success('Returned to Super Admin session');
    navigate('/superadmin/dashboard');
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1400,
        bgcolor: '#7C3AED',
        color: 'white',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        borderBottom: '2px solid #5B21B6',
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Visibility sx={{ fontSize: 18 }} />
        <Typography variant="body2" fontWeight={600}>
          Viewing as:
        </Typography>
        <Chip
          label={user?.school?.name ?? 'School'}
          size="small"
          sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 600, fontSize: '0.75rem' }}
        />
        <Typography variant="body2" sx={{ opacity: 0.85 }}>
          ({user?.email})
        </Typography>
        <Chip
          label="Support View"
          size="small"
          icon={<Warning sx={{ fontSize: '14px !important', color: '#FDE68A !important' }} />}
          sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: '#FDE68A', fontSize: '0.7rem', ml: 0.5 }}
        />
      </Box>

      <Button
        size="small"
        variant="outlined"
        startIcon={exiting ? <CircularProgress size={14} color="inherit" /> : <ExitToApp />}
        onClick={handleExit}
        disabled={exiting}
        sx={{
          color: 'white',
          borderColor: 'rgba(255,255,255,0.5)',
          '&:hover': {
            borderColor: 'white',
            bgcolor: 'rgba(255,255,255,0.1)',
          },
          fontSize: '0.75rem',
          py: 0.25,
          flexShrink: 0,
        }}
      >
        {exiting ? 'Exiting…' : 'Exit to Super Admin'}
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
